import { Color } from '@diritto/common/style/color';

export const NaverLoginIcon = ({ color = Color.White }: { color?: string }) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M14.8491 12.5627L8.9182 4H4V20H9.15088V11.436L15.0831 20H20V4H14.8491V12.5627Z" fill={color} />
  </svg>
);
